module.exports = __webpack_public_path__ + "static/img/148_TO8_1861.d3795b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/148_TO8_1861.jpg
// module id = KEaU
// module chunks = 0